export default "__VITE_ASSET__31db332e__"